import { render, staticRenderFns } from "./task_evaluation_unfinished.vue?vue&type=template&id=022a6265&scoped=true&"
import script from "./task_evaluation_unfinished.vue?vue&type=script&lang=js&"
export * from "./task_evaluation_unfinished.vue?vue&type=script&lang=js&"
import style0 from "./task_evaluation_unfinished.vue?vue&type=style&index=0&id=022a6265&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022a6265",
  null
  
)

export default component.exports